/*
 * @Author: v_smwang
 * @Date: 2020-07-27 15:51:55
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-07-29 16:30:31
 * @FilePath: \src\config\index.js
 * @Description: 描述
 * @Module: 模块路径
 */
// 通过 webpack 来获取平台id，见根目录下的 vue.config.js 文件

export default {
  Theme: {
    primary: '#1890FF',
    navTheme: 'light',
    layout: 'sidemenu', // sidemenu, topmenu
    contentWidth: 'Fixed',
    fixedHeader: true,
    fixSiderbar: false,
    autoHideHeader: false,
    colorWeak: false,
    multiTab: true,
  },
  Storage: {
    namespace: 'tks__',
    name: 'ls',
    storage: 'local',
  },
  BasicConf: {
    platformId: 'image_annotate',
  },
  System: {
    title: '公共系统平台',
    defaultAvatar: `${process.env.BASE_URL}avatar.jpg`,
  },
};
